import "./Realizations.css";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { RealizationsBannerSection } from "./RealizationsBannerSection";
import { RealizationsShowcaseSection } from "./RealizationsShowcaseSection";
const importAll = (r) => r.keys().map(r);

const arthurContext = require.context(
  "../../assets/images/realizations/arthur",
  false,
  /\.(jpg|jpeg|png)$/
);
const arthurImages = importAll(arthurContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Arthur VH BuildUp!",
  thumbnailAlt: "Arthur VH BuildUp!",
  thumbnailTitle: "Arthur VH BuildUp!",
  description: "Arthur VH BuildUp!",
}));

const justitiaContext = require.context(
  "../../assets/images/realizations/justitia",
  false,
  /\.(jpg|jpeg|png)$/
);
const justitiaImages = importAll(justitiaContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Justitia VH BuildUp!",
  thumbnailAlt: "Justitia VH BuildUp!",
  thumbnailTitle: "Justitia VH BuildUp!",
  description: "Justitia VH BuildUp!",
}));

const nachtegaalContext = require.context(
  "../../assets/images/realizations/nachtegaal",
  false,
  /\.(jpg|jpeg|png)$/
);
const nachtegaalImages = importAll(nachtegaalContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Nachtegaal VH BuildUp!",
  thumbnailAlt: "Nachtegaal VH BuildUp!",
  thumbnailTitle: "Nachtegaal VH BuildUp!",
  description: "Nachtegaal VH BuildUp!",
}));

const terheydeContext = require.context(
  "../../assets/images/realizations/terheyde",
  false,
  /\.(jpg|jpeg|png)$/
);
const terheydeImages = importAll(terheydeContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Ter Heyde VH BuildUp!",
  thumbnailAlt: "Ter Heyde VH BuildUp!",
  thumbnailTitle: "Ter Heyde VH BuildUp!",
  description: "Ter Heyde VH BuildUp!",
}));

const hamptonContext = require.context(
  "../../assets/images/realizations/hampton",
  false,
  /\.(jpg|jpeg|png)$/
);
const hamptonImages = importAll(hamptonContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Hampton By Hilton Central Station VH BuildUp!",
  thumbnailAlt: "Hampton By Hilton Central Station VH BuildUp!",
  thumbnailTitle: "Hampton By Hilton Central Station VH BuildUp!",
  description: "Hampton By Hilton Central Station VH BuildUp!",
}));

const gagelContext = require.context(
  "../../assets/images/realizations/gagel",
  false,
  /\.(jpg|jpeg|png)$/
);
const gagelImages = importAll(gagelContext).map((img) => ({
  original: img,
  thumbnail: img,
  loading: "eager",
  thumbnailLoading: "eager",
  originalAlt: "Gagel VH BuildUp!",
  thumbnailAlt: "Gagel VH BuildUp!",
  thumbnailTitle: "Gagel VH BuildUp!",
  description: "Gagel VH BuildUp!",
}));

export const Realizations = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>VH BuildUp! - {t("helmet.title.realizations")}</title>
        <meta name="description" content={t("helmet.meta.realizations")} />
      </Helmet>
      <RealizationsBannerSection />
      <RealizationsShowcaseSection
        project="arthur"
        images={arthurImages}
        autoPlay={true}
      />
      <RealizationsShowcaseSection project="justitia" images={justitiaImages} />
      <RealizationsShowcaseSection
        project="nachtegaal"
        images={nachtegaalImages}
      />
      <RealizationsShowcaseSection project="terheyde" images={terheydeImages} />
      <RealizationsShowcaseSection project="hampton" images={hamptonImages} />
      <RealizationsShowcaseSection project="gagel" images={gagelImages} />
    </>
  );
};
